import angular from 'angular';

module.exports = angular.module('market.models.listing-offer', [])
.factory('ListingOffer', function($resource) {
  var ListingOffer = $resource('/api/v1/listing_offers/:id', { id: '@id' }, {
    claimListingOfferByToken: {
      method: 'POST',
      url: '/api/v1/listing_offers/claim_listing_offer_by_token',
    },
  });
  return ListingOffer;
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/listing-offer.js
 **/